export const DATE_TIME_FORMAT = 'mmm d, yyyy h:MM TT';

export const DATE_FORMAT = 'mmm d, yyyy';
